import { Flex } from "@redotech/redo-web/flex";
import { Text } from "@redotech/redo-web/text";
import { memo, type ReactNode } from "react";
import * as styles from "./bis.module.css";

export const ProductDetailHeader = memo(function ProductDetailHeader({
  name,
  subtitle,
  imageUrl,
  stats,
}: {
  name: string;
  subtitle: string;
  imageUrl: string | undefined;
  stats: ReactNode;
}) {
  return (
    <Flex gap="xl" px="xl" py="lg">
      <Flex
        align="center"
        bgColor="tertiary"
        borderRadius="xl"
        className={styles.detailImage}
        justify="center"
        shrink={0}
      >
        {imageUrl ? (
          <img
            alt={name}
            src={imageUrl}
            style={{
              width: "100%",
              height: "100%",
              objectFit: "cover",
              borderRadius: "8px",
            }}
          />
        ) : (
          <Text fontSize="sm" textColor="secondary">
            [img]
          </Text>
        )}
      </Flex>
      <Flex dir="column" gap="md">
        <Flex dir="column" gap="xs">
          <Text fontSize="xl" fontWeight="semibold" textColor="primary">
            {name}
          </Text>
          <Text fontSize="sm" textColor="secondary">
            {subtitle}
          </Text>
        </Flex>
        {stats}
      </Flex>
    </Flex>
  );
});

export function StatItem({
  value,
  label,
  color = "primary",
}: {
  value: string;
  label: string;
  color?: "primary" | "success";
}) {
  return (
    <Flex dir="column" gap="none">
      <Text fontSize="xl" fontWeight="bold" textColor={color}>
        {value}
      </Text>
      <Text fontSize="xs" textColor="secondary">
        {label}
      </Text>
    </Flex>
  );
}
